import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';
import { AppSettings } from 'src/app/app.settings';
import {
  MarketingCampaignAnalyticsResponse,
  SentEmailFilterInterface,
  SentEmailInterface
} from 'src/app/interfaces/campaigns/history/history.interface';

@Injectable({
  providedIn: 'root'
})
export class MarketingCampaignsHistoryService {

  constructor(
    private baseRestAngular: ApiClient,
    private restAngular: ApiClient
  ) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular(): ApiClient {
    return this.baseRestAngular.withBaseUrl(AppSettings.getMarketingEndpoint());
  }

  getAll(params: SentEmailFilterInterface): Promise<{ history: SentEmailInterface[], count: number }> {
    return this.restAngular.one('history').customGET('', params).toPromise();
  }

  getAnalytics(params: SentEmailFilterInterface): Promise<MarketingCampaignAnalyticsResponse> {
    return this.restAngular.one('history').one('analytics').customGET('', params).toPromise();
  }

  getById(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }
}
